/* eslint-disable */
import * as v1 from "./matsuri-forms.v1";
export const matsuriForms = { v1 };
